<script setup>
import { IconCreativeCommons, IconCreativeCommonsBy } from '@tabler/icons-vue';

defineProps({
    info: {
        type: Object,
        required: false,
    },
});
</script>

<template>
    <div class="flex gap-1 flex-wrap text-xs items-center mt-1 bg-gray-50 p-1 rounded" v-if="info">
        <div v-if="info.license" class="text-gray-500">
            <div v-if="info.license === 'CC-BY'" title="Creative Commons By">
                <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" class="flex gap-1 items-center">
                    <IconCreativeCommons class="h-4 w-4" />
                    <IconCreativeCommonsBy class="h-4 w-4" />
                </a>
            </div>
        </div>
        <div v-if="info.title" class="italic">"{{ info.title }}"</div>
        <div v-if="info.author">
            <a :href="info.url" v-if="info.url" target="_blank" class="text-indigo-400">
                © {{ $t('messages.by_author', { author: info.author }) }}
            </a>
            <span v-else class="text-gray-500"> © {{ $t('messages.by_author', { author: info.author }) }} </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CopyrightNotice',
};
</script>
